import { render, staticRenderFns } from "./form_person.vue?vue&type=template&id=fb249128&scoped=true"
import script from "./form_person.vue?vue&type=script&lang=js"
export * from "./form_person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb249128",
  null
  
)

export default component.exports